import { get } from 'lodash';
import { useParams } from 'react-router-dom';

export default (paramName: string = 'postSlug') => {
  const params = useParams();
  const idFromParams = get(params, paramName)?.match(/\d+/g)?.[0];

  return Number(idFromParams);
};
